import { faKey, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import Section from 'components/base/Section';
import EcoimDefaultAddressCard from 'components/cards/EcoimDefaultAddressCard';
import EcomProfileCard from 'components/cards/EcomProfileCard';
import EcomVendorCard from 'components/cards/EcomVendorCard';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import ProfileDetailsTab from 'components/modules/e-commerce/profile/ProfileDetailsTab';
import { defaultBreadcrumbItems } from 'data/commonData';
import { Col, Container, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { RootState } from 'redux-state/store';

const Profile = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const customerDetails = useSelector(
    (state: RootState) => state.user.customer
  );
  const vendorDetails = useSelector((state: RootState) => state.user.vendor);

  return (
    <Container className="px-xl-0 px-xxl-3 mt-5">
      <Row className="align-items-center justify-content-between g-3 mb-4">
        <Col xs="auto">
          <h2 className="mb-0">
            {user?.role === 'customer' ? 'Customer' : 'Vendor'} Profile
          </h2>
        </Col>
        <Col xs="auto" className="d-flex flex-wrap gap-2 gap-sm-3">
          {/* <Button
              variant="phoenix-danger"
              startIcon={<FontAwesomeIcon className="me-2" icon={faTrashAlt} />}
            >
              Delete custome
              r
            </Button> */}
          <Button
            variant="phoenix-secondary"
            startIcon={<FontAwesomeIcon className="me-2" icon={faKey} />}
          >
            Reset password
          </Button>
        </Col>
      </Row>
      <Row className="g-3 mb-6">
        <Col xs={12} lg={8}>
          {user?.role === 'customer' ? <EcomProfileCard /> : <EcomVendorCard />}
        </Col>
        <Col xs={12} lg={4}>
          <EcoimDefaultAddressCard
            address={
              user?.role === 'customer'
                ? customerDetails.billingAddress
                : vendorDetails.address
            }
            email={
              user?.role === 'customer'
                ? customerDetails.email
                : vendorDetails.email
            }
            phone={
              user?.role === 'customer'
                ? customerDetails.phone
                : vendorDetails.phone
            }
            role=""
          />
        </Col>
      </Row>
      <ProfileDetailsTab
        role={user?.role}
        vendorId={user?.role === 'vendor' ? user?._id : undefined}
      />
    </Container>
  );
};

export default Profile;
